import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { MOBILE } from '@app/constants';

const initialInnerWidth = window.innerWidth;
const initialInnerHeight = window.innerHeight;

export const useWindowSize = () => {
  const [innerHeight, setInnerHeight] = useState<number>(initialInnerHeight);
  const [innerWidth, setInnerWidth] = useState<number>(initialInnerWidth);

  const { pathname } = useLocation();

  // Subscribe once on mount; clean up on unmount. The previous implementation
  // used [innerHeight, innerWidth] as deps with no cleanup — every resize event
  // added a new listener without removing the old one, accumulating indefinitely.
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
      setInnerWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Re-read sizes after navigation in case the layout changed between routes.
  useEffect(() => {
    setInnerHeight(window.innerHeight);
    setInnerWidth(window.innerWidth);
  }, [pathname]);

  return {
    innerHeight,
    innerWidth,
    isMobile: innerWidth <= MOBILE,
  };
};
